export default {
  log(...args) {
    const { hostname } = window.location;
    const env = process.env.VUE_APP_ENV;
    
    if (hostname.endsWith('avare.no')) {
      return;
    }
    
    if (env !== 'development' && env !== 'productionTest') {
      return;
    }

    console.log('[LOG]', ...args);
  }
};
